import { render, staticRenderFns } from "./DisableDialog.vue?vue&type=template&id=845b30d4&scoped=true&"
import script from "./DisableDialog.vue?vue&type=script&lang=js&"
export * from "./DisableDialog.vue?vue&type=script&lang=js&"
import style0 from "./DisableDialog.vue?vue&type=style&index=0&id=845b30d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845b30d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VDialog,VImg,VRow,VSwitch})
